import {
  CLOSE_DOCTOR_LOCATOR_MODAL,
  OPEN_DOCTOR_LOCATOR_MODAL,
  SET_COMPONENT_IS_LOADED_STATUS,
} from './mutations'
export const ACTION_SHOW_DOCTOR_LOCATOR = 'ACTION_SHOW_DOCTOR_LOCATOR'
export const ACTION_HIDE_DOCTOR_LOCATOR = 'ACTION_HIDE_DOCTOR_LOCATOR'
export const ACTION_LOCK_DOCTOR_LOCATOR_SCRIPT = 'ACTION_LOCK_DOCTOR_LOCATOR_SCRIPT'

export const ACTION_SET_COMPONENT_IS_LOADED_STATUS = 'ACTION_SET_COMPONENT_IS_LOADED_STATUS'

export const actions = {
  [ACTION_SHOW_DOCTOR_LOCATOR]: function ({ commit }) {
    commit(OPEN_DOCTOR_LOCATOR_MODAL)
  },
  [ACTION_HIDE_DOCTOR_LOCATOR]: function ({ commit }) {
    commit(CLOSE_DOCTOR_LOCATOR_MODAL)
  },
  [ACTION_SET_COMPONENT_IS_LOADED_STATUS]: function ({ commit }) {
    commit(SET_COMPONENT_IS_LOADED_STATUS)
  },
}
